export const DEFAULT_LEGAL_REGION = 'gb';
